import clsx from 'clsx';
import React from 'react';

import type { ScrollFaderController } from './useScrollFaderController';

/**
 * Indicate whether a scrollable box can scroll with a fade out effect.
 */
export function ScrollFader(props: {
    className?: string;
    children: React.ReactNode;
    controller: ScrollFaderController;
}) {
    const { children, className, controller } = props;
    const { resizeRef, start, end, orientation } = controller;
    return (
        <div
            ref={resizeRef}
            aria-orientation={orientation}
            className={clsx(
                'relative h-full overscroll-contain',
                start &&
                    "before:pointer-events-none before:absolute before:inset-0 before:z-[1] before:bg-gradient-to-r before:from-0% before:from-[--sp-color-bg-base] before:to-10% before:to-transparent before:content-[''] aria-[orientation='vertical']:before:bg-gradient-to-b",
                end &&
                    "after:pointer-events-none after:absolute after:inset-0 after:z-[1] after:bg-gradient-to-l after:from-0% after:from-[--sp-color-bg-base] after:to-10% after:to-transparent after:content-[''] aria-[orientation='vertical']:after:bg-gradient-to-t",
                className
            )}
        >
            {React.Children.only(children)}
        </div>
    );
}
